import { useSelector } from 'react-redux';
import { settingsSelector } from 'state/selectors/settings';
import { teamsSelector } from 'state/selectors/teams';
import { Collaborations } from './collaborationSettings.types';
import { getSettings } from './collaborationSettings.formatter';

/**
 * Collaboration settings hook that receives a colloaboration type and
 * returns org settings for this collaboration
 * @returns Org settings
 */
const useCollaborationSettings = ({ collaborationType }: {collaborationType: Collaborations}) => {
  const allSettings = useSelector(settingsSelector);
  const allTeams = useSelector(teamsSelector);
  return getSettings({ allSettings, allTeams, collaborationType });
};

export default useCollaborationSettings;
